/* eslint-disable no-unused-vars */
import { isEmpty } from '@ember/utils';
import { isArray } from '@ember/array';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';

export function getErrorMessages(err) {
  let errorMessages = [];
  let error = err.errors[0];
  if (!isEmpty(error) && !isEmpty(error.detail)) {
    if (!error.detail.includes('ValidationErrors')) {
      errorMessages.push(error.title);
      errorMessages.push(error.detail);
    } else {
      try {
        let parsedError = JSON.parse(error.detail);
        if (
          !isEmpty(parsedError.Elements) &&
          isArray(parsedError.Elements) &&
          !isEmpty(parsedError.Elements[0].ValidationErrors)
        ) {
          let validationErrors = parsedError.Elements[0].ValidationErrors;
          errorMessages = mapBy(validationErrors, 'Message');
        }
      } catch (parseError) {
        errorMessages.push('Unknown Error');
        return errorMessages;
      }
    }
  }
  if (isEmpty(errorMessages)) {
    errorMessages.push('Unknown Error');
  }
  return errorMessages;
}
